import Vue from 'vue';
import VueRouter from 'vue-router';
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)
export default new VueRouter({
  // "linkActiveClass":"actived",
  "linkExactActiveClass": "actived",
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/home.vue'),
      meta: {},
      redirect: '/index',
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('@/pages/home.vue'),
          meta: {}
        },
      ]
    },
    {
      path: '/',
      name: 'manager',
      component: () => import('@/pages/manager.vue'),
      meta: {},
      redirect: '/index',
      children: [
        {
          path: '/manager',
          name: 'manager',
          component: () => import('@/pages/manager.vue'),
          meta: {}
        },
      ]
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/pages/index.vue'),
      meta: {}
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login.vue'),
      meta: {}
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/register.vue'),
      meta: {}
    },
    {
      path: '/printPdf',
      name: 'printPdf',
      component: () => import('@/pages/projectSum/printPdf.vue'),
      meta: {},
    }
  ]
})

